/**
 * Equipos de ventas (VEN-516). Espejo del catálogo del server
 * (`domain/catalogs/equipo-venta.catalog.ts`), que es el dueño: acá está
 * duplicado solo porque la pantalla de Usuarios, donde se asigna el equipo,
 * no tiene acceso a `/ventas-comisiones/catalogos` (pide `view:ventas-comisiones`,
 * que un admin no tiene por default). Ventas/Comisiones sigue leyendo el
 * catálogo del backend. Si se suma un equipo, va en los dos lados.
 */
import { UserRole } from '../types';

export type EquipoVenta = 'geo' | 'sol';

export const EQUIPOS_VENTA: { key: EquipoVenta; label: string }[] = [
  { key: 'geo', label: 'Equipo Geo' },
  { key: 'sol', label: 'Equipo Sol' },
];

export function esEquipoVenta(v: string): v is EquipoVenta {
  return EQUIPOS_VENTA.some((e) => e.key === v);
}

/** Roles que no gestionan ventas: no tiene sentido ponerlos en un equipo. */
const ROLES_SIN_EQUIPO: ReadonlySet<UserRole> = new Set([
  UserRole.USUARIO_EMPRESA,
  UserRole.INTEGRACION,
]);

export function puedeTenerEquipo(rol: UserRole): boolean {
  return !ROLES_SIN_EQUIPO.has(rol);
}
